<div class="sc-wrap" (click)="$event.stopPropagation()">
  <button type="button" class="sc-trigger" [class.sc-trigger--open]="open" (click)="toggleOpen($event)">
    <span class="sc-trigger__label">{{ buttonLabel }}</span>
    <i class="fas fa-chevron-down sc-trigger__chevron" [class.sc-trigger__chevron--open]="open"></i>
  </button>

  @if (open) {
    <div class="sc-panel">
      <div class="sc-search">
        <i class="fas fa-search"></i>
        <input type="text" [(ngModel)]="filterText" placeholder="Search classes..." />
      </div>
      <div class="sc-tree">
        @if (filteredNodes.length === 0) {
          <div class="sc-empty">No classes found</div>
        }
        <ng-container *ngTemplateOutlet="treeLevel; context: { nodes: filteredNodes, depth: 0 }"></ng-container>
      </div>
    </div>
  }
</div>

<ng-template #treeLevel let-nodes="nodes" let-depth="depth">
  @for (node of nodes; track node.text) {
    <div>
      <button
        type="button"
        class="sc-node"
        [class.sc-node--leaf]="isLeaf(node)"
        [class.sc-node--active]="isLeaf(node) && value != null && (node.value?.value ?? node.value) == value"
        [style.padding-left.rem]="0.75 + depth * 1"
        (click)="toggleNode(node, $event)">
        @if (!isLeaf(node)) {
          <i class="fas sc-node__caret" [class.fa-caret-right]="!isExpanded(node)" [class.fa-caret-down]="isExpanded(node)"></i>
        } @else {
          <i class="fas fa-users sc-node__leaf-icon"></i>
        }
        <span>{{ node.text }}</span>
        @if (isLeaf(node) && value != null && (node.value?.value ?? node.value) == value) {
          <i class="fas fa-check sc-node__check"></i>
        }
      </button>
      @if (!isLeaf(node) && isExpanded(node)) {
        <ng-container *ngTemplateOutlet="treeLevel; context: { nodes: node.children, depth: depth + 1 }"></ng-container>
      }
    </div>
  }
</ng-template>
